import { connect } from 'react-redux'

import * as actions from './actions'
import RankingsBoxTable from './RankingsBoxTable'
import * as selectors from './selectors'

const mapStateToProps = state => ({
  indicator: selectors.indicator(state),
  ranking: selectors.ranking(state),
  rankingsCountries: selectors.rankingsCountries(state),
  sort: selectors.sort(state),
})

const mapDispatchToProps = {
  onSort: actions.setSort,
}

export default connect(mapStateToProps, mapDispatchToProps)(RankingsBoxTable)
